/**
 * 화면 영역을 "보이는 그대로" 캡처해 A4 PDF로 저장.
 * html2canvas + jspdf 는 호출 시에만 동적 로드 (pdf 청크 — pdfService 와 동일 패턴).
 */
export async function downloadElementAsPdf(
  element: HTMLElement,
  fileName: string,
  orientation: 'portrait' | 'landscape' = 'portrait'
): Promise<void> {
  const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
    import('html2canvas'),
    import('jspdf'),
  ]);

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    logging: false,
  });
  if (!canvas) throw new Error('화면 캡처에 실패했습니다.');

  const pdf = new jsPDF(orientation === 'landscape' ? 'l' : 'p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // 페이지 폭에 맞춰 비율 유지, 세로로 길면 여러 페이지로 분할
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * pageWidth) / canvas.width;
  const imgData = canvas.toDataURL('image/png');

  let offset = 0;
  while (offset < imgHeight) {
    if (offset > 0) pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, -offset, imgWidth, imgHeight);
    offset += pageHeight;
  }

  pdf.save(fileName);
}
